//home.js
'use strict';
document.addEventListener('DOMContentLoaded', () => {
	if (typeof window.jQuery !== 'undefined') {
		const pickup = document.querySelector('.js-pickup');
		if (pickup) {
			const $pickup = window.jQuery(pickup);
			if (typeof $pickup.slick === 'function') {
				$pickup.slick({
					slidesToShow: 3,
					slidesToScroll: 1,
					arrows: true,
					dots: true,
					infinite: true,
					prevArrow:
						'<button type="button" class="slick-prev pickup-arrow pickup-arrow--prev">前へ</button>',
					nextArrow:
						'<button type="button" class="slick-next pickup-arrow pickup-arrow--next">次へ</button>',
					responsive: [
						{
							breakpoint: 1024,
							settings: {
								slidesToShow: 2,

							},
						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 1,

							},
						},
					],
				});
			}
		}
	}

	const mainVisual = document.querySelector('.js-mainVisual');
	if (!mainVisual || typeof window.jQuery === 'undefined') {
		return;
	}

	const $mainVisual = window.jQuery(mainVisual);
	if (typeof $mainVisual.slick !== 'function') {
		return;
	}

	$mainVisual.slick({
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 4500,
		speed: 1000,
		cssEase: 'ease',
		pauseOnHover: false,
		pauseOnFocus: false,
		adaptiveHeight: false,
		centerMode: true,
		centerPadding: '14vw',
		slidesToShow: 1,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					centerPadding: '15px',
				},
			},
		],
	});

});
